import React from 'react'
import images from 'assets/imagesAsset'

interface SearchToShowDataProps {
  title?: string
}

function SearchToShowData({ title }: SearchToShowDataProps) {
  return (
    <>
      <img
        src={images.no_data}
        alt="no-data"
        style={{ width: '170px', height: '170px' }}
      />
      <p style={{ fontSize: '16px' }}>
        {title || 'Không tìm thấy dữ liệu phù hợp'}
      </p>
    </>
  )
}

export default SearchToShowData
